import React from 'react';
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
import { ArchiveViewerView, useArchiveViewerContext } from "../../context";
export const ViewerControlTooltip = props => {
  const {
    children,
    show,
    tooltip
  } = props;
  const {
    view
  } = useArchiveViewerContext();
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    show: show,
    delay: {
      show: 500,
      hide: 0
    },
    placement: view === ArchiveViewerView.MODAL ? 'bottom' : undefined,
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      className: "viewer-archive-tooltip"
    }, tooltip)
  }, children);
};